<template>
    <div class="banner">
        <!-- <el-carousel height="100vh" direction="vertical" :autoplay="true" :interval="1000" :loop="true">
          <el-carousel-item v-for="item in 3" :key="item">
          </el-carousel-item>
        </el-carousel> -->
        <el-carousel height="100vh" :autoplay="true" :interval="3000" :loop="true">
          <el-carousel-item v-for="(item, index) in 3" :key="item" @click="toProDetail(index)">
            <div class="btn" v-if="index===0">
              <a href="https://s.tb.cn/c.0vHL86" target="_blank">{{ $t('common.buyNow') }}</a>
            </div>
          </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script setup>
import { reactive,onMounted  } from 'vue'
const { $aos } = useNuxtApp()
const state = reactive({
   
})
const toProDetail = (index) =>{
  if(index===1){
    navigateTo(`/proDetail/${0}`)
  }else if(index===2){
    navigateTo('/detail/2')
  }
}
onMounted(()=>{
  $aos().init({
    easing: 'ease-out-back',
    duration: 2000,
  })
})
</script>

<style lang="less" scoped>
@media (max-width: 800px) {
  /* 在屏幕宽度小于等于800px时应用的样式 */
  // .el-carousel__item:nth-child(3){
  //   background: red;
  // }
}
.el-carousel__item:nth-child(3){
    background-image: url("http://jinbaihui-bucket.oss-cn-shenzhen.aliyuncs.com/temp/0d8502be02e28c56a25c1c45acf1126.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    position: relative;
  }
  .el-carousel__item:nth-child(4){
    background-image: url("http://jinbaihui-bucket.oss-cn-shenzhen.aliyuncs.com/temp/42478d9291d0729276a7afb38ec0f22.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .el-carousel__item:nth-child(5){
    background-image: url("http://jinbaihui-bucket.oss-cn-shenzhen.aliyuncs.com/temp/924d7eea258981c8c786930a9531733.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }

  :deep(.el-carousel__indicators){
    // margin-bottom: 20px;
  }
  :deep(.el-carousel__button){
    background-color: rgba(0, 160, 233, 1);
  }
  :deep(.el-carousel__button) {
    // height: 50px !important;
  }
  .btn{
    width: 64px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    border: 1px solid #00A0E9;
    border-radius: 11px;
    color: #00A0E9;
    position: absolute;
    bottom: 50px;
    left: 400px;
    cursor: pointer;
    animation: expand-border 1s infinite;
    a{
      text-decoration: none;
      color: #00A0E9;
      font-size: 8px;
    }
  }
  @keyframes expand-border {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 160, 233, 0.3);;
  }
  100% {
    box-shadow: 0 0 0 10px rgba(0, 160, 233, 0.1);;
  }
}
</style>